import { useEffect } from "react";
import { App as AntApp } from "antd";
import { Button } from "../../design-system";
import { useNewVersionAvailable } from "../../utils/useNewVersionAvailable";

/**
 * Soft "new version available" prompt.
 *
 * Polls /version.json (see useNewVersionAvailable) and surfaces a sticky
 * notification when a deploy ships while the tab is open. Without this,
 * users only learn about the new build when their browser tries to lazy-
 * load a removed chunk and the ChunkErrorBoundary catches the failure.
 *
 * Mount once near the App root, inside <AntApp> so notification picks up
 * the right theme.
 */

const NOTIFICATION_KEY = "hrp-new-version-available";

const NewVersionWatcher = () => {
    const { notification } = AntApp.useApp();
    const newVersionAvailable = useNewVersionAvailable();

    useEffect(() => {
        if (!newVersionAvailable) return undefined;

        notification.open({
            key: NOTIFICATION_KEY,
            message: "New version available",
            description:
                "A newer version of HR Platform has been deployed. Reload when convenient — save any in-progress edits first.",
            duration: 0, // sticky until reload or manual dismiss
            btn: (
                <Button type="primary" onClick={() => window.location.reload()}>
                    Reload
                </Button>
            ),
        });

        return () => {
            notification.destroy(NOTIFICATION_KEY);
        };
    }, [newVersionAvailable, notification]);

    return null;
};

export default NewVersionWatcher;
